import { useState, useEffect } from "react";
import { LatLngTuple } from "leaflet";
import { useNavigate, Form, ActionFunctionArgs, useActionData } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { consumeFrom, myAxios } from "src/components/common/functions";
import Notification from "src/components/common/notification";
import logo from "src/img/logo.png";
import { useAuthStore } from "src/components/main/authStore";
import { Link } from "react-router-dom";
//--------------------------------------------------------------------------------------------
export const user: {
    userName: string, // real export
    coords: LatLngTuple,
    accuracy: number,
    [key: string]: any
} = {
    userName: "", 
    coords: [37.6148754, -122.0874473],
    accuracy: 0
};
export default function Login(){
    const setAuthenticated = useAuthStore(state => state.setAuthenticated);
    const setAuthChecked = useAuthStore(state => state.setAuthChecked);
    const setUserInfo = useAuthStore(state => state.setUserInfo);
    const setToken = useAuthStore(state => state.setToken);
    const navigate = useNavigate();
    const defaultNotification: {
        show: boolean, 
        title?: string, 
        msg?: string, 
        callBack?: Function, 
        preventClose?: boolean
    } = { 
        show: false, 
        title: "", 
        msg: ""
    };
    const [notification, setNotification] = useState(defaultNotification);
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [password, setPassword] = useState(localStorage.getItem("password") || "");
    const [rememberPassword, setRememberPassword] = useState(localStorage.getItem("rememberPassword") === "true");
    const handleRememberPassword = () => {
        setRememberPassword(!rememberPassword);
        if(rememberPassword){
            //unchecked
            localStorage.removeItem("password");
            localStorage.removeItem("rememberPassword");
        }else{
            //checked
            localStorage.setItem("rememberPassword", "true");
        }
    }
    const actionData = useActionData();
    useEffect(() => {
        if (!actionData) return;
        if (actionData.ok === false) {
            setNotification({
                show: true,
                title: actionData.title,
                msg: actionData.msg,
            });
            return;
        }
        const navigateAfterLogin = () => {
            const from = consumeFrom();
            navigate(from, {state: { external: true}, replace: true});
        };
        const finalizeLogin = () => {
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(pos => {
                    user.coords = [pos.coords.latitude, pos.coords.longitude]; // update user
                    user.accuracy = pos.coords.accuracy; // update user
                }, error => alert(error.message), {enableHighAccuracy: true, timeout: 5000});  
            }else{
                window.alert("Unable to get your location!");
            }
            if(actionData.popName){
                sessionStorage.setItem("pendingNewspaperPopName", actionData.popName);
                sessionStorage.setItem("pendingNewspaperPopData", actionData.pop || "");
                navigateAfterLogin();
            }else{
                navigateAfterLogin();
            }
        };
        localStorage.setItem("email", email);
        if(rememberPassword){
            localStorage.setItem("password", actionData.password);
        }else{
            localStorage.removeItem("password");
        }
        setToken(actionData.token ?? null);
        setAuthenticated(true);
        setAuthChecked(true);
        setUserInfo(actionData.user); // update user state
        if(actionData.update && actionData.versionMessage){
            setNotification(
                {   
                    show : true, 
                    title: "Update", 
                    msg: actionData.versionMessage, 
                    callBack: finalizeLogin
                }
            );
        }else{
            finalizeLogin();
        }
    }, [actionData, rememberPassword, email, navigate, setAuthChecked, setAuthenticated, setToken, setUserInfo]);
    //--------------------------------------------------------------------------------------------
    return (
        <div className = "loginBox">
            <img className = "cssLoginLogo" src = {logo} alt = ""/>  
            <Form method = "post">          
                <input className = "bwinput" type = "email" placeholder = "Email" id = "email" name = "email" value = {email} onChange = {e => setEmail(e.currentTarget.value.toLowerCase())} required autoComplete = "off"/>
                <input className = "bwinput" type = "password" placeholder = "Password" id = "password" name = "password" value = {password} onChange = {e => setPassword(e.currentTarget.value)} required autoComplete = "off"/>
                <button type = "submit" className = "bwbtn">SIGN IN</button>
                <Link className = "bwbtn text-decoration-none" to = "/ForgetPassword">FORGET PASSWORD</Link>
            </Form>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <Link type = "button" className = "bwbtn text-decoration-none" to = "/ChangePassword">CHANGE PASSWORD</Link>
                        </td>
                        <td>
                            <input id = "rememberPassword" type = "checkbox" checked = {rememberPassword} onChange = {handleRememberPassword}/>
                            <label id = "rememberPasswordLabel" htmlFor = "rememberPassword">Remember Password</label>
                        </td>
                    </tr>
                </tbody>    
            </table>
            {notification.show?
            <Notification
                title = {notification.title || ""}
                msg = {notification.msg || ""}
                closeIt = {notification.preventClose ?
                () => {} :
                (notification.callBack ?
                    notification.callBack :
                    () => setNotification({ show : false })
                )}
            />:null}
        </div>
    );
}

export async function loginAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    const email = formData.get("email");
    const password = formData.get("password");
    if (!email || !password) {
        return {
            ok: false,
            title: "Error",
            msg: "Missing credentials",
        };
    }
    const res = await myAxios({ fileName: "auth/auth.php", formData: formData });
    if(!res) return;
    return {
        ...res.data, 
        password
    };
}
